import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Tooltip,
  Typography
} from '@mui/material'
import { useEffect, useState } from 'react'
import { GiftCardPaymentLinkDialogProps } from './types'
import CopyIcon from '@mui/icons-material/FileCopy'
import { PaymentLinkWrapper } from './styled'
import { adminService } from 'shared/api'
import { useAppDispatch } from 'store'
import { MessageTypes, showMessage } from 'store/slices/message-slice'

function GiftCardPaymentLinkDialog(props: GiftCardPaymentLinkDialogProps) {
  const dispatch = useAppDispatch()

  const [processing, setProcessing] = useState(false)
  const [paymentLink, setPaymentLink] = useState<string>('')
  useEffect(() => {
    setPaymentLink('')
    setProcessing(false)
  }, [props.open])

  async function handleCreatePaymentLink() {
    setProcessing(true)

    try {
      const data = await adminService.giftCard.getPaymentLink({ giftCardId: props.giftCardId })
      if (data.data.paymentLink) {
        setPaymentLink(data.data.paymentLink)
      }
    } finally {
      setProcessing(false)
    }
  }

  function handleLinkCopy(paymentLink: string) {
    return () => {
      navigator.clipboard.writeText(paymentLink)
      dispatch(showMessage({ text: 'Ссылка скопирована в буфер обмена', type: MessageTypes.Success }))
    }
  }

  return (
    <Dialog open={props.open} onClose={props.onClose}>
      <DialogTitle>Получение ссылки на оплату сертификата</DialogTitle>
      <DialogContent>
        <Button
          type="submit"
          variant="outlined"
          disabled={processing || !!paymentLink}
          fullWidth
          style={{ marginTop: '1rem' }}
          onClick={handleCreatePaymentLink}
        >
          Получить ссылку на оплату
        </Button>
        {!!paymentLink && (
          <PaymentLinkWrapper>
            <Typography
              component="a"
              target="_blank"
              href={paymentLink}
              style={{ marginTop: '1rem', wordBreak: 'break-word' }}
            >
              {paymentLink}
            </Typography>
            <Tooltip title="Скопировать в буфер обмена">
              <IconButton size="small" onClick={handleLinkCopy(paymentLink)}>
                <CopyIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </PaymentLinkWrapper>
        )}
      </DialogContent>
      <DialogActions>
        <Button type="submit" variant="outlined" disabled={processing} onClick={props.onClose}>
          Закрыть
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export { GiftCardPaymentLinkDialog }
